export default {
  degrees: [],
  projects: [],
  faculties: [],
  departments: [],
  prefixes: [],
  curriculums: [],
  assessments: [],
  subjectGroups: [],
  subjects: []
}